import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent, WmsTypeaheadComponent } from '@wms/components';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { reject, isString, indexOf, includes, isNil, isFunction, find } from 'lodash-es';
import { FilterCriteriaService, I18nService, LiveWidgetUtilsService } from '@wms/services';
import { BaseVariableService, VariableCrudManagerService } from '@wms/variables';
import { WmsExpressionErrorDirective } from '@wms/app/directives/wms-expression-error/wms-expression-error.directive';
import { CommonWidgetDirective } from "@wms/directives";

@Component({
  standalone: true,
  selector: 'wms-criteria-rule',
  templateUrl: './wms-criteria-rule.component.html',
  styleUrls: ['./wms-criteria-rule.component.less'],
  imports: [CommonModule, FormsModule, TooltipModule, WmsTypeaheadComponent, WmsExpressionErrorDirective, CommonWidgetDirective]
})
export class WmsCriteriaRuleComponent extends BaseComponent implements OnInit {
  @Input() rule: any;
  @Input() parentGroup: any;
  @Input() liveWidgetSettingsService: any;

  doBinding: any; // TO DO
  booleanFieldOptions: any = {
    'true': true,
    'false': false
  }
  matchModeMsgs: any;
  matchModesMap: any;
  matchModes: any;

  constructor(private i18Service: I18nService, private liveWidgetUtilsService: LiveWidgetUtilsService, public filterCriteriaService: FilterCriteriaService,public baseVariableService: BaseVariableService,public varCrudManagerService: VariableCrudManagerService) {
    super();
  }

  ngOnInit(): void {
    this.init();
  }

  init() {
    let defaultLocale = this.i18Service.getAppDefaultLocale();
    let appLocale = this.i18Service.getAppLocaleBundle(defaultLocale);
    this.matchModeMsgs = this.liveWidgetUtilsService.getMatchModeMsgs(appLocale?.systemMessages);
    this.matchModesMap = this.liveWidgetUtilsService.getMatchModeTypesMap(true);
    this.matchModes = this.matchModesMap[this.rule?.type || 'string'];
  }

  onFilterFieldSelect($event: any) {
    this.rule.target = $event.value || $event;
    this.filterCriteriaService.markVariableUpdated();
    /**
    * we need this if condition, this takes care of post migration effects of applying the single matchmode
    * to all data types resulting in not showing any value in the matchmode drop down in the new Query builder
    *
    * to avoid this we are checking whether a valid match is applied or not. If its not a valid, we assign the first value
    * from the valid matchmodes list for that data type.
    */
    if (indexOf(this.matchModes, this.rule.matchMode) === -1) {
      this.rule.matchMode = this.matchModes[0];
    }

    this.matchModes = this.matchModesMap[this.filterCriteriaService.data.fieldsTypeMap[this.rule.target] || 'default'];
    this.rule.type = this.filterCriteriaService.data.fieldsTypeMap[this.rule.target] || 'string';
    this.rule.value = this.rule.secondvalue = '';
    this.rule.matchMode = this.matchModes[0];
  }

  clearBinding(arg?: any) {
    //to differentiate between first or second bind value. here from second text bind we are passing the argument
    arguments.length ? this.rule.secondvalue = "" : this.rule.value = "";
    this.filterCriteriaService.markVariableUpdated();
  }

  onBindCallbackForSelectedComponent(pNameObj: any, ruleObj: any) {
    let pName = pNameObj.field, type = pNameObj.dataType;
    let propertyObj = {type: type};
    this.liveWidgetSettingsService.openWidgetBindVariableDialog(propertyObj, pName, (propertyDetails: any, boundVariable: any) => {
      ruleObj.isFirst ? ruleObj.value = boundVariable : ruleObj.secondvalue = boundVariable;
    }, true);
  }

  /**
   * This is called onclick of the bind icon in the query builder
   * bind callback implementation for the query builder.
   * @param pNameObj - Property Object with all the property details pased on by the query builder
   * @param ruleObj
   */
  onBindCallback = (pNameObj: any, ruleObj: any) => {
    let propertyName = "wm_input_" + pNameObj.field;
    let propertyObj;
    if (this.baseVariableService.selectedVariable) {
      propertyObj = this.baseVariableService.selectedVariable.propertyObj[propertyName];
    } else {
      this.onBindCallbackForSelectedComponent(pNameObj, ruleObj);
      return;
    }
    /**
     * once the binding is complete in the dialog, we receive the property details along with the new bound value(boundVariable)
     * Attach it to the rule obj passed from the query builder. This will the update Query builder UI
     * @param propertyDetails
     * @param boundVariable
     */
    let callbackFunction = (propertyDetails: any, boundVariable: any) => {
      ruleObj.isFirst ? ruleObj.value = boundVariable : ruleObj.secondvalue = boundVariable;
    };

    if (this.baseVariableService.selectedVariable) {
      this.varCrudManagerService.openBindVariableDialog(propertyObj, propertyName, callbackFunction, false);
    } else {
      this.liveWidgetSettingsService.openBindVariableDialog(propertyObj, pNameObj.field, 'field');
    }
  }

  openBindDialog(arg?: any) {
    if (!isNil(this.rule.target) && this.rule.target !== "") {
      if (this.showBinding() && isFunction(this.onBindCallback)) {
        //to differenciate between first or second bind value. here from second text bind we are passing the argument
        arguments.length ? this.rule.isFirst = false : this.rule.isFirst = true;
        this.onBindCallback(find(this.filterCriteriaService.filterFields, (o: any) => { return o.displayName === this.rule.target }), this.rule);
      }
    }
  }

  deleteRule() {
    this.parentGroup.rules = reject(this.parentGroup.rules, this.rule);
    // this is to avoid invalid state. Always keep one rule in the group
    if (!this.parentGroup.rules.length) {
      this.filterCriteriaService.addRule(this.parentGroup);
    }
    this.filterCriteriaService.markVariableUpdated();
  }

  showBinding() {
    var showBinding = true;
    if(!isNil(this.doBinding) && !this.doBinding ) {
      showBinding = false;
    }
    return showBinding;
  }

  getMatchModes() {
    this.matchModes = this.matchModesMap[this.rule.type || 'string'];
    return this.matchModes;
  }

  showInput() {
    return this.isEmptyRule(this.rule.matchMode);
  }

  isEmptyRule(mode: any) {
    let isEmpty = includes(['null', 'empty', 'nullorempty', 'isnotnull', 'isnotempty'], mode);
    if(isEmpty) {
      this.rule.value = "";
    }
    return isEmpty;
  }

  getMatchModeKey(matchMode: any) {
    return this.locale['LABEL_MATCHMODE_' + this.matchModeMsgs[matchMode].split(' ').join('_').toUpperCase()] || this.matchModeMsgs[matchMode];
  }

  matchModeOnChange() {
    /**
     * change the value to empty if the value contains commas like 1,2,3 which is format required for 'in' mode,
     */
    if (['in', 'notin'].indexOf(this.rule.matchMode) === -1 && isString(this.rule.value) && this.rule.value.indexOf(",") !== -1) {
      this.rule.value = "";
    }
    this.filterCriteriaService.markVariableUpdated();
  }

}
